import React, { useState } from "react";
import {
	ENGLISH_LANGUAGE_CODE_LK,
	BURMESE_LANGUAGE_CODE_LK,
	CHINESE_LANGUAGE_CODE_LK,
} from "@constants";
import { MMFlag, Flag, ENGFlag } from "@assets";
import { localStorage } from "@utils";
import { useDispatch } from "react-redux";
import { saveUserPreferedLanguage } from "@redux/app/appSlice";
import { api } from "@api";
import { changeLocale } from "@i18n";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal as AntModal } from "antd";
import { RadioNotSelectedIcon, RadioSelectedIcon } from "@assets";

export const LangCard = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	flex-direction: row;

	width: calc(100% - 32px);
	padding: 10px 14px;
	border-radius: 12px;
	background-color: ${(props) =>
		props.bordered === "true" ? "#FFF8B3" : "#fff"};
	cursor: pointer;

	img{
		border-radius: 50%;
		width: 24px;
		height: 24px;
	}
`;

export const LangLabel = styled.span`
	flex: 1;
	color: #1E1E1E;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */
`;

export const LanModal = styled(AntModal)`

	.ant-modal-content {
		padding: 24px !important;
		border-radius: 12px;
		padding: 0 !important;
		margin: 0 !important;
	}

	.ant-modal-title {
		padding: 16px 24px 0 !important;
		color: #1E1E1E;
		text-align: center;
		font-size: 18px;
		font-style: normal;
		font-weight: 700;
		line-height: 30px; /* 150% */
	}
`;


const LanguageModal = ({ open, handleClose }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();
	const [selectedLanguage, setSelectedLanguage] =
		useState(userPreferedLanguage);
	
	const handleClick = (id) => {
		setSelectedLanguage(id);
		changeAppLanguage(id);
	}

	const changeAppLanguage = (selectedLanguage) => {
		const lang = selectedLanguage;
		// change i18n locale
		changeLocale(lang);

		// update lang in redux
		dispatch(saveUserPreferedLanguage(lang));

		// update lang in request obj
		api.setUserPreferedLanguage(lang);

		handleClose();
	};

	const onCancel = () => {
		setSelectedLanguage(userPreferedLanguage);
		handleClose();
	};

	const languages = [
		{
			id: CHINESE_LANGUAGE_CODE_LK,
			img: Flag,
			label: t("common.chinese"),
		},
		{
			id: ENGLISH_LANGUAGE_CODE_LK,
			img: ENGFlag,
			label: t("common.english"),
		},
		{
			id: BURMESE_LANGUAGE_CODE_LK,
			img: MMFlag,
			label: t("common.burmese"),
		},
	];

	return (
		<LanModal
			title={t("profile.changeLanguage")}
			centered
			destroyOnClose
			open={open}
			closable={false}
			width={310}
			okText={t("common.ok")}
			onCancel={onCancel}
			footer={null}
			className="lang-modal"
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-around",
					alignItems: "center",
					padding: "0 12px 24px",
					gap: 4,
				}}
			>
				{languages.map((lang) => (
					<LangCard
						key={lang.id}
						bordered={selectedLanguage === lang.id ? "true" : "false"}
						onClick={() => handleClick(lang.id)}
					>
						<img src={lang.img} alt={lang.label} />
						<LangLabel
							isSelected={selectedLanguage === lang.id ? "true" : "false"}
						>
							{lang.label}
						</LangLabel>

						{
							selectedLanguage === lang.id ? (
								<RadioSelectedIcon />
							) : (
								<RadioNotSelectedIcon />
							)
						}
					</LangCard>
				))}
			</div>
		</LanModal>
	);
};

export default LanguageModal;
